module.exports = __webpack_public_path__ + "static/media/signal-energy.6be7e888.png";